import LP_api from 'react-sdk/LP_api'
import AppState from './AppState'

class ReaxeAPI {
  api = null
  verbose = true
  #moduleCallbacks = new Map()

  constructor() {

    this.api = new LP_api()
    // window.LP_API = lp_api


    this.api.onCallfunction = (name, data) => {
      if (this.verbose)
        console.info("REAXE - from game : ", name, "(", data, ")")

      // le backend est init
      if(name === "signalGameReady" ) {
        AppState.onBackendReady();
      } else if (name === "signalGameWaiting") {
        AppState.onBackendWaiting();
      } else if(name === "haxeToReact" ) {
        let {module, event, params} = data.data

        if (module) {
          let cb = this.#moduleCallbacks.get(module);
          if (cb) {
            cb(event, params, data.done);
            return;
          }
        }
        // on arrive ici si y'a pas de module indiqué ou pas de module correspond, dans ce cas on appelle le callback directement
        if (data.done)
          data.done()
      }


    }
  }

  /**
   *
   * @param {String} module
   * @param {(event : String, params)} cb
   */
  registerModule(module, cb) {
    this.#moduleCallbacks.set(module, cb)
  }

  toHaxe(module, event, params = null) {
    if (this.verbose)
      console.info("REAXE - toHaxe(", module, ", ", event, ", ", params, ")")
    return new Promise((resolve) => {
      this.api.registeredFunctions.reactToHaxe({
        "module" : module,
        "event" : event,
        "params" : params
      }, resolve);
    } );
  }

}


export default ReaxeAPI
